import { ElementRef, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { HttpClient, HttpEventType, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { of, Subject, combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, takeUntil } from 'rxjs/operators';
import { TitleCasePipe } from 'pipes/titlecase.pipe';
import { ApplicationService, } from 'services/application/application.service';
import { ConfigService } from 'services/config/config.service';
import { DialogService } from 'services/dialogs/dialogs.service';
import { ErrorService } from 'services/error/error.service';
import { SplashService } from 'services/splash/splash.service';
import { UserService } from 'services/user/user.service';
import { UnsavedChangesService } from 'routes/routes.guard';
import { FileUploadService } from 'modules/fileupload/fileupload.service';
import { FileSizePipe } from 'pipes/filesize.pipe';
var CreateComponent = /** @class */ (function () {
    function CreateComponent(appSvc, configSvc, datePipe, dlgSvc, errorSvc, fb, fileSizePipe, fileUploadSvc, http, location, route, router, splashSvc, titleCasePipe, unsavedChangesSvc, userSvc) {
        this.appSvc = appSvc;
        this.configSvc = configSvc;
        this.datePipe = datePipe;
        this.dlgSvc = dlgSvc;
        this.errorSvc = errorSvc;
        this.fb = fb;
        this.fileSizePipe = fileSizePipe;
        this.fileUploadSvc = fileUploadSvc;
        this.http = http;
        this.location = location;
        this.route = route;
        this.router = router;
        this.splashSvc = splashSvc;
        this.titleCasePipe = titleCasePipe;
        this.unsavedChangesSvc = unsavedChangesSvc;
        this.userSvc = userSvc;
        this._subrelease = new Subject();
    }
    CreateComponent.prototype.ngAfterContentInit = function () {
        if (this.SubjectInput) {
            this.SubjectInput.nativeElement.focus();
        }
    };
    CreateComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
        // Stop tracking
        this.TakeDownTracking();
    };
    CreateComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AllCategories = null;
        self.AllSchools = null;
        self.BoardMembers = null;
        self.ChangesDetected = false;
        self.IsBoardAssistant = false;
        // Set a flag if this is an iOS device, since those cannot do file attachment uploads
        self.IsiPad = window.navigator.userAgent.indexOf('iPad') >= 0 || window.navigator.userAgent.indexOf('iPhone') >= 0;
        self.IsRelatedCreation = false;
        self.RelatedRequest = null;
        self.RelatedRequestID = null;
        self.SelectedTabIndex = 0;
        self.User = null;
        self.ViewReady = false;
        self.WorkdayCalendar = [];
        // Wait for the first non-null user info object
        self.userSvc.UserSubject.pipe(takeUntil(self._subrelease), first(function (_u) { return !!_u && !!_u.AuthToken; })).subscribe(function (_user) {
            self.User = _user;
            self.IsBoardAssistant = self.User.CurrentRole === 'BoardAssistant';
            // Initialize the form group
            self.BuildRequestFormGroup();
            // Subscribe to constant user changes, to keep AuthToken in sync.
            self.userSvc.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (user) {
                self.User = user;
                self.IsBoardAssistant = (self.User && self.User.CurrentRole) === 'BoardAssistant';
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
            // Set up form tracking by backing up the request form contents
            self.OriginalRequestInfo = JSON.stringify(self.RequestForm.getRawValue());
            self.ChangesDetected = false;
            self.SetupTracking();
            // Load data for component
            combineLatest(self.appSvc.GetAllSchools(), self.appSvc.GetAllCategories(), self.appSvc.GetAllBoardMembers(), self.appSvc.GetWorkdayCalendar(true), self.route.params)
                .pipe(takeUntil(self._subrelease), map(function (_p) {
                return {
                    Schools: _p[0],
                    Categories: _p[1],
                    Board: _p[2],
                    Workdays: _p[3],
                    Params: _p[4],
                };
            }))
                .subscribe(function (packet) {
                self.AllSchools = packet.Schools || [];
                self.AllCategories = packet.Categories || [];
                self.BoardMembers = packet.Board || [];
                self.WorkdayCalendar = packet.Workdays || [];
                self.RelatedRequestID =
                    packet.Params && packet.Params.RelatedRequestID != null ? +packet.Params.RelatedRequestID : null;
                // If we have a related request ID, load it now so we can populate the creation form with the related data from the related request.
                if (self.RelatedRequestID != null) {
                    self.appSvc
                        .GetRequest(self.User.AuthToken, self.User.CurrentRole, self.RelatedRequestID, true)
                        .subscribe(function (request) {
                        self.RelatedRequest = request;
                        self.IsRelatedCreation = true;
                        self.UpdateWithRelatedRequest();
                        // Display dialog box.
                        self.dlgSvc
                            .OpenMessageBoxDialog({
                            TitleText: 'Related Request Notice',
                            MessageText: "This request is being created as a related request to a previously closed " +
                                "request in the IRIS system:<br /><br /><strong>Original Request Subject: </strong>" +
                                (self.RelatedRequest.Subject + "<br /><strong>Board Member: </strong>") +
                                (self.titleCasePipe.transform(self.RelatedRequest.RequestorInfo.FirstName) + " ") +
                                (self.titleCasePipe.transform(self.RelatedRequest.RequestorInfo.LastName) + "<br />") +
                                ("<strong>Closed on: </strong>" + self.datePipe.transform(self.RelatedRequest.DateClosed, 'M/d/yy h:mm a')) +
                                "<br /><br />Since this request being created is a related request, some fields in " +
                                "this creation form have been preconfigured with information from the original request, " +
                                "<strong>including the original priority.</strong> You may update or change these " +
                                "values as needed. When this new related request is assigned in the system, the " +
                                "original board member listed here will be notified of the creation of the related " +
                                "request via email.",
                            OKText: 'OK',
                        })
                            .subscribe();
                        self.ViewReady = true;
                    }, function (error) {
                        // Is this an unauthorized access? If so, display a kinder message. Otherwise, fail out with an error splash.
                        var errorInfo = self.errorSvc.RetrieveServiceError(error);
                        if (errorInfo.ErrorMessage.startsWith('User is not authorized to view') ||
                            errorInfo.ErrorMessage.includes('could not be located in the database')) {
                            // Don't do anything with this.
                        }
                        else {
                            self.errorSvc.HandleServiceError(error);
                        }
                        self.ViewReady = true;
                    });
                }
                else {
                    self.ViewReady = true;
                }
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
        }, function (error) { return self.errorSvc.HandleServiceError(error); });
    };
    // #region Add New Request
    CreateComponent.prototype.AddNewRequest = function () {
        var _this = this;
        var self = this;
        if (!self.User) {
            return;
        }
        if (self.RequestForm.invalid) {
            self.dlgSvc
                .OpenMessageBoxDialog({
                TitleText: 'Information Missing',
                MessageText: "One of more items that are required to create this request are missing. Please " +
                    "review the subject, priority, request text, and any other fields with red highlighting and " +
                    "provide the necessary information in order to proceed. Thank you.",
                OKText: 'OK',
            })
                .subscribe();
            var _formval = self.RequestForm.getRawValue();
            Object.keys(_formval).forEach(function (k) {
                var ctrl = self.RequestForm.get(k);
                ctrl.markAsTouched();
            });
            return;
        }
        var formval = self.RequestForm.getRawValue();
        // If this is a board member creating the request, or it was not but it is being requested on behalf of a board
        // member, we have to adjust the form values as needed.
        if (self.User.CurrentRole === 'BoardMember') {
            formval.Source = 0;
            formval.RequestedBySAPID = self.User.SAPID;
        }
        else {
            // Is this being created as a board request on their behalf?
            if (formval.Source === 0) {
                formval.RequestedBySAPID = formval.RequestBoardMember && formval.RequestBoardMember.SAPID;
            }
            else {
                // A constituent request. The RequestedBySAPID field now becomes the facilitator/person entering this request.
                formval.RequestedBySAPID = self.User.SAPID;
            }
        }
        // Is this being created as a related request? If so, we need to set that field in the form packet also.
        if (self.IsRelatedCreation) {
            formval.IsRelatedRequest = true;
            formval.RelatedRequestID = self.RelatedRequest.RequestID;
        }
        // TODO! Check for the word "file" or "attachment" in the request text, and if no attachments are added, get a confirmation to continue?
        // Send the creation request off to the service for adding to the system. First set a splash so the user knows what's going on.
        // TODO: Update this to show file upload status somehow?
        // TODO!
        // var pendingFiles = $rootScope.plugins.Uploader.getNotUploadedItems();
        var pendingFiles = null;
        self.splashSvc
            .OpenSplash({
            TitleText: 'Please Wait',
            MessageText: "Creating " + (self.IsRelatedCreation ? 'related ' : '') + "request" + (formval.RequestUploadAttachments && !!formval.RequestUploadAttachments.length ? ' & uploading attachments' : ''),
        })
            .subscribe(function () {
            // Send the new request to the server. Begin by packing the request object that will be sent to the API.
            var formData = new FormData();
            // Store all files in the form data
            for (var _i = 0, _a = formval.RequestUploadAttachments; _i < _a.length; _i++) {
                var file = _a[_i];
                formData.append('file', file.File, file.File.name);
            }
            // Set the parameters now for the call: AuthToken, Source, infoObject, etc.
            formData.append('AuthToken', self.User.AuthToken || '');
            formData.append('infoObject', JSON.stringify({
                RequestText: formval.RequestText,
                Source: formval.Source,
                SourceDescription: formval.SourceDescription,
                RequestedBySAPID: formval.RequestedBySAPID,
                Subject: formval.Subject,
                SchoolNumber: formval.SchoolNumber,
                CategoryID: formval.RequestCategory && formval.RequestCategory.CategoryID,
                BoardDistrict: formval.BoardDistrict,
                Priority: formval.Priority,
                Confidential: formval.Confidential != null ? formval.Confidential : '',
                DueDate: formval.DueDate,
                SourceNotes: formval.SourceNotes,
                ConstituentName: formval.ConstituentName,
                ConstituentEmail: formval.ConstituentEmail,
                ConstituentPhone: formval.ConstituentPhone,
                ConstituentPrivate: formval.ConstituentPrivate,
                IsRelatedRequest: formval.IsRelatedRequest != null ? formval.IsRelatedRequest : '',
                RelatedRequestID: formval.RelatedRequestID != null ? formval.RelatedRequestID : '',
            }));
            // Set the http Headers
            var headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
            // Create an http-post request and pass the form, while telling the request to report upload
            // progress.
            var req = new HttpRequest('POST', self.configSvc.hostAddress + 'Api/Services/IRIS/AddRequest', formData, {
                //                headers: headers,
                reportProgress: true,
            });
            // Send the http-post request and subscribe for progress updates on it.
            _this.http.request(req).subscribe(function (event) {
                if (event.type === HttpEventType.UploadProgress) {
                    // Calculate the progress percentage.
                    var percentDone = Math.round((100 * event.loaded) / event.total);
                    // Update the progress BehaviorSubject with the new calculation.
                    // const newentry = {...progress.value};
                    // newentry.PercentComplete = percentDone;
                    // progress.next(newentry);
                }
                else if (event instanceof HttpResponse) {
                    // Close the progress BehaviorSubject as the upload is now complete.
                    // const oldval = {...progress.value};
                    // oldval.isComplete = true;
                    // oldval.isInProgress = false;
                    // Set the final file information so the client can update the UI.
                    var requestInfo = event.body;
                    // oldval.FinalFileInfo = (fileInfo && fileInfo[0]);
                    // if (oldval.FinalFileInfo) {
                    //     oldval.FinalFileInfo.DateUploaded = (oldval.FinalFileInfo.DateUploaded ?
                    //         new Date(oldval.FinalFileInfo.DateUploaded) : null);
                    // }
                    // Send out one more update before closing it.
                    // progress.next(oldval);
                    // progress.complete();
                    // Splash the success
                    self.splashSvc.CloseSplash();
                    self.splashSvc.SnackbarSuccess("Request #" + requestInfo.RequestIssueNumber + " Added Successfully.");
                    // Clear the entry form so a new one could be entered.
                    self.ClearRequestForm(false);
                }
            }, function (error) {
                // const oldval = {...progress.value};
                // oldval.Error = error.error;
                // oldval.isError = true;
                // oldval.isInProgress = false;
                // progress.error(oldval);
                self.errorSvc.HandleServiceError(error);
            }, function () { });
            // self.appSvc.AddRequest(self.User.AuthToken, formval).subscribe(
            //  request => {
            // Got the resulting request. At this point, we now have a request ID number available. If there were file attachments set up, now is the time
            // to push those as well.
            // The request is completed, and all files (if any) are uploaded. We can now proceed to alert the user and clear the form.
            //      self.splashSvc.CloseSplash();
            // self.splashSvc.SnackbarSuccess(`Request #${request.RequestIssueNumber} added successfully.`, 5000);
            // Clear the entry form so a new one could be entered.
            // self.ClearRequestForm();
            // },
            // error => self.errorSvc.HandleServiceError(error)
            // );
        }, function (error) { return self.errorSvc.HandleServiceError(error); });
    };
    // #endregion
    // #region Build Request Form Group
    CreateComponent.prototype.BuildRequestFormGroup = function () {
        var self = this;
        // Build the request form
        self.RequestForm = self.fb.group({
            RequestID: [null],
            Subject: ['', Validators.required],
            RequestCategory: [null],
            DueDate: [null],
            Priority: [null],
            Confidential: [false],
            Source: [0],
            SourceDescription: [null],
            RequestBoardMember: [null],
            SchoolNumber: [null],
            BoardDistrict: [null],
            RequestText: ['', Validators.required],
            RequestUploadAttachments: self.fb.array([]),
            SourceNotes: [null],
            IsConstituent: [false],
            ConstituentName: [''],
            ConstituentEmail: [''],
            ConstituentPhone: ['', Validators.pattern(/^(?:\(?\d{3}(?:\)\s?|-)?)?\d{3}-?\d{4}$/)],
            ConstituentPrivate: [true],
        });
        // If the current user is a facilitator or developer, other fields are required for creation in this form. Board members do not
        // need to / cannot provide this information.
        if (['Developer', 'Facilitator'].includes(self.User.CurrentRole)) {
            self.RequestForm.get('DueDate').setValidators(Validators.required);
            self.RequestForm.get('RequestCategory').setValidators(Validators.required);
            self.RequestForm.get('RequestBoardMember').setValidators(Validators.required);
        }
        // If the current user is a board member, board assistant, facilitator, or developer, the priority is required for creation in this form.
        if (['BoardMember', 'BoardAssistant', 'Facilitator', 'Developer'].includes(self.User.CurrentRole)) {
            self.RequestForm.get('Priority').setValidators(Validators.required);
        }
        // If the current user is a board assistant, they must provide the board member, so it is required.
        if (self.User.CurrentRole === 'BoardAssistant') {
            self.RequestForm.get('RequestBoardMember').setValidators(Validators.required);
        }
        // #region Setup new request subscriptions
        // Watch for changes to the priority. When it changes, either set or reset the request due date based upon the set priority.
        self.RequestForm.get('Priority')
            .valueChanges.pipe(distinctUntilChanged(), debounceTime(250))
            .subscribe(function (value) {
            var addedDays = 0;
            if (value === 4) {
                // Low priority. Wipe out the due date (if currently set)
                self.RequestForm.get('DueDate').setValue('');
                return;
            }
            switch (value) {
                case 1: // Urgent - 24 hours
                    addedDays = 1;
                    break;
                case 2: // High - 2 days
                    addedDays = 2;
                    break;
                case 3: // Routine - 5 days
                    addedDays = 5;
                    break;
            }
            if (addedDays > 0) {
                // Get the new due date
                var dueDate = self.appSvc.GetDueDate(addedDays);
                // Set the form property now
                self.RequestForm.get('DueDate').setValue(dueDate);
            }
        });
        // Watch for changes to the request type. When it changes, if the source is 0 (board), wipe out the source property.
        self.RequestForm.get('Source')
            .valueChanges.pipe(distinctUntilChanged(), debounceTime(250))
            .subscribe(function (value) {
            if (value === 0) {
                self.RequestForm.get('SourceDescription').setValue('');
            }
        });
        // Watch for changes to the school number, so we can tie the district selection to the school's district or the board selection.
        // If the school is changing to a different district than the previously selected district or board member, we need to warn
        // and decide how to handle this.
        self.RequestForm.get('SchoolNumber')
            .valueChanges.pipe(distinctUntilChanged(), debounceTime(250))
            .subscribe(function (value) {
            if (!value) {
                return;
            }
            // Try to find this school via the school number set.
            var school = (self.AllSchools || []).find(function (s) { return s.SchoolNumber === value; });
            if (school && school.District && school.District !== 'X') {
                var rdistrict = self.RequestForm.get('BoardDistrict').value;
                var rboard = self.RequestForm.get('SourceDescription').value;
                var wrongDistrict_1 = !!rdistrict && rdistrict !== school.District;
                var wrongBoard_1 = !!rboard && rboard.District !== school.District;
                if (wrongDistrict_1 || wrongBoard_1) {
                    // There is a mismatch in place. Alert and get a desired action to handle this.
                    var msg = "The school which was just selected " + school.SchoolName + " - District " + school.District + " appears " +
                        "to have a different district than ";
                    var issues = '';
                    if (wrongDistrict_1 && wrongBoard_1) {
                        msg +=
                            "both the board member (" + rboard.FirstName + " " + rboard.LastName + " - District " + rboard.District + ") " +
                                ("and the board district (District " + rdistrict + ")");
                        issues = 'board member and board district';
                    }
                    else if (wrongDistrict_1) {
                        msg += "the board district (District " + rdistrict + ")";
                        issues = 'board district';
                    }
                    else {
                        msg += "the board member (" + rboard.FirstName + " " + rboard.LastName + " - District " + rboard.District + ")";
                        issues = 'board member';
                    }
                    (msg +=
                        " currently selected. Although you can proceed, this mismatch may cause issues with searching " +
                            ("for this request in the future. Would you like to remove the currently selected " + issues + ", or keep ") +
                            "the settings as they are?"),
                        self.dlgSvc
                            .OpenConfirmationDialog({
                            TitleText: 'District Mismatch(es) Detected',
                            MessageText: msg,
                            OKText: 'Remove Invalid Setting(s)',
                            CancelText: 'Keep Setting(s)',
                        })
                            .subscribe(function (result) {
                            if (result === true) {
                                // Remove the invalid board member and/or district
                                if (wrongBoard_1) {
                                    self.RequestForm.get('SourceDescription').setValue(null);
                                }
                                if (wrongDistrict_1) {
                                    self.RequestForm.get('BoardDistrict').setValue('');
                                }
                            }
                        });
                }
            }
        });
        // Watch for changes to the district, so we can remove the currently selected school if it doesn't match the new district
        self.RequestForm.get('BoardDistrict')
            .valueChanges.pipe(distinctUntilChanged(), debounceTime(250))
            .subscribe(function (value) {
            if (!value) {
                return;
            }
            // Get the currently selected board member, so we can determine the board member's district
            var rboard = self.RequestForm.get('SourceDescription').value;
            // Get the currently selected school, so we can determine the school's district
            var schoolNumber = self.RequestForm.get('SchoolNumber').value;
            var rschool = null;
            if (schoolNumber != null) {
                rschool = self.AllSchools.find(function (s) { return s.SchoolNumber === schoolNumber; });
            }
            var wrongBoard = !!rboard && rboard.District !== value;
            var wrongSchool = !!rschool && rschool.District && rschool.District !== 'X' && rschool.District !== value;
            if (wrongBoard || wrongSchool) {
                // There is a mismatch in place. Alert and get a desired action to handle this.
                var msg = "The board district which was just selected (District " + value + ") appears " +
                    "to have a different district than ";
                var issues = '';
                if (wrongSchool && wrongBoard) {
                    msg +=
                        "both the board member (" + rboard.FirstName + " " + rboard.LastName + " - District " + rboard.District + ") " +
                            ("and the school (" + rschool.SchoolName + " - District " + rschool.District + ")");
                    issues = 'board member and school';
                }
                else if (wrongSchool) {
                    msg += "the school (" + rschool.SchoolName + " - District " + rschool.District + ")";
                    issues = 'school';
                }
                else {
                    msg += "the board member (" + rboard.FirstName + " " + rboard.LastName + " - District " + rboard.District + ")";
                    issues = 'board member';
                }
                (msg +=
                    " currently selected. Although you can proceed, this mismatch may cause issues with searching " +
                        ("for this request in the future. Would you like to remove the currently selected " + issues + ", or keep ") +
                        "the settings as they are?"),
                    self.dlgSvc
                        .OpenConfirmationDialog({
                        TitleText: 'District Mismatch(es) Detected',
                        MessageText: msg,
                        OKText: 'Remove Invalid Setting(s)',
                        CancelText: 'Keep Setting(s)',
                    })
                        .subscribe(function (result) {
                        if (result === true) {
                            // Remove the invalid board member and/or school
                            if (wrongBoard) {
                                self.RequestForm.get('SourceDescription').setValue(null);
                            }
                            if (wrongSchool) {
                                self.RequestForm.get('SchoolNumber').setValue('');
                            }
                        }
                    });
            }
        });
        // Watch for changes to the board member, so we can remove the currently selected school and/or district if it doesn't match the new board's district
        self.RequestForm.get('RequestBoardMember')
            .valueChanges.pipe(distinctUntilChanged(), debounceTime(250))
            .subscribe(function (value) {
            if (!value) {
                return;
            }
            // Get the currently selected district
            var rdistrict = self.RequestForm.get('BoardDistrict').value;
            // Get the currently selected school, so we can determine the school's district
            var schoolNumber = self.RequestForm.get('SchoolNumber').value;
            var rschool = null;
            if (schoolNumber != null) {
                rschool = self.AllSchools.find(function (s) { return s.SchoolNumber === schoolNumber; });
            }
            var wrongDistrict = !!rdistrict && rdistrict !== value.District;
            var wrongSchool = !!rschool && rschool.District && rschool.District !== 'X' && rschool.District !== value.District;
            if (wrongDistrict || wrongSchool) {
                // There is a mismatch in place. Alert and get a desired action to handle this.
                var msg = "The board member which was just selected (" + value.FirstName + " " + value.LastName + " - District " + value.District + ") appears " + "to have a different district than ";
                var issues = '';
                if (wrongSchool && wrongDistrict) {
                    msg +=
                        "both the board district (District " + rdistrict + ") " +
                            ("and the school (" + rschool.SchoolName + " - District " + rschool.District + ")");
                    issues = 'board district and school';
                }
                else if (wrongSchool) {
                    msg += "the school (" + rschool.SchoolName + " - District " + rschool.District + ")";
                    issues = 'school';
                }
                else {
                    msg += "the board district (District " + rdistrict + ")";
                    issues = 'board district';
                }
                (msg +=
                    " currently selected. Although you can proceed, this mismatch may cause issues with searching " +
                        ("for this request in the future. Would you like to remove the currently selected " + issues + ", or keep ") +
                        "the settings as they are?"),
                    self.dlgSvc
                        .OpenConfirmationDialog({
                        TitleText: 'District Mismatch(es) Detected',
                        MessageText: msg,
                        OKText: 'Remove Invalid Setting(s)',
                        CancelText: 'Keep Setting(s)',
                    })
                        .subscribe(function (result) {
                        if (result === true) {
                            // Remove the invalid board district and/or school
                            if (wrongDistrict) {
                                self.RequestForm.get('BoardDistrict').setValue('');
                            }
                            if (wrongSchool) {
                                self.RequestForm.get('SchoolNumber').setValue('');
                            }
                        }
                    });
            }
        });
        self.RequestForm.valueChanges
            .pipe(takeUntil(self._subrelease), debounceTime(250), distinctUntilChanged(function (x, y) { return JSON.stringify(x) === JSON.stringify(y); }))
            .subscribe(function (value) {
            self.ChangesDetected = JSON.stringify(value) !== self.OriginalRequestInfo;
        });
        // #endregion
    };
    // #endregion
    // #region Can Deactivate
    CreateComponent.prototype.CanDeactivate = function (liveCheck) {
        var self = this;
        if (!self.RequestForm) {
            return true;
        }
        // Are there unsaved changes?
        if (!self.ChangesDetected) {
            // No. The user can deactivate.
            return true;
        }
        // If this is a live check (native from browser), forego the confirmation dialog as the native
        // browser will catch instead.
        if (liveCheck === true) {
            return false;
        }
        // Need to prompt
        return self.dlgSvc.OpenConfirmationDialog({
            TitleText: 'Unsaved Changes Detected',
            MessageText: "The new request form appears to have unsaved changes which have not yet been submitted " +
                "to the system. If you leave this page now, your unsaved changes will be lost. Do you wish " +
                "to discard your changes and leave the page?",
            OKText: 'Yes - Discard Changes',
            CancelText: 'No - Stay On Page',
        });
    };
    // #endregion
    // #region Clear Request Form
    CreateComponent.prototype.ClearRequestForm = function (confirmationNeeded) {
        var self = this;
        (confirmationNeeded !== true
            ? of(true)
            : self.dlgSvc.OpenConfirmationDialog({
                TitleText: 'Clear Form?',
                MessageText: 'Are you sure you wish to clear the new request form?',
                OKText: 'Yes - Clear',
                CancelText: 'No - Cancel',
            })).subscribe(function (result) {
            if (result === true) {
                self.requestfrm.resetForm();
                self.RequestForm.patchValue({
                    RequestID: null,
                    Subject: '',
                    RequestCategory: null,
                    DueDate: null,
                    Priority: null,
                    Source: 0,
                    SourceDescription: '',
                    SchoolNumber: '',
                    BoardDistrict: '',
                    RequestText: '',
                    ConstituentName: '',
                    ConstituentEmail: '',
                    ConstituentPhone: '',
                    ConstituentPrivate: true,
                    Confidential: false,
                }, { emitEvent: false });
                // Clear out any pending upload attachments
                self.RequestForm.setControl('RequestUploadAttachments', self.fb.array([]));
                self.SelectedTabIndex = 0;
                // If this was for a related request, clear out those properties.
                if (self.IsRelatedCreation) {
                    self.IsRelatedCreation = false;
                    self.RelatedRequestID = null;
                    // Re-route without navigation to the normal path.
                    var url = self.router.createUrlTree(['create']).toString();
                    self.location.go(url);
                }
                // Update tracking
                self.OriginalRequestInfo = JSON.stringify(self.RequestForm.getRawValue());
                // Focus the subject input
                if (self.SubjectInput) {
                    self.SubjectInput.nativeElement.focus();
                }
            }
        });
    };
    // #endregion
    // #region Handle File Attachment
    CreateComponent.prototype.HandleFileAttachment = function (files) {
        if (!files || !files.length) {
            return;
        }
        var self = this;
        // Add each file selected to the form array, if it is not already scheduled for uploading.
        var reqUploadsArr = self.RequestForm.get('RequestUploadAttachments').getRawValue();
        var reqUploads = (reqUploadsArr || []).map(function (f) { return f.File.name; });
        var badFiles = [];
        files.forEach(function (file) {
            var fileName = file.File.name;
            // Is this file already scheduled for uploading? If it is, we need to park the info in the badFiles array,
            // so we can alert afterwards. Otherwise, put it in the queue to be uploaded.
            if (reqUploads.includes(fileName)) {
                badFiles.push(file.File);
            }
            else {
                // We can include this file.
                var fileGp = self.fb.group({
                    File: [file.File],
                });
                self.RequestForm.get('RequestUploadAttachments').push(fileGp);
                // Store the file info for reference in this loop.
                reqUploads.push(fileName);
            }
        });
        // If any "bad" files were encountered, pop up an alert about it now, to let the user now.
        if (badFiles.length) {
            self.dlgSvc
                .OpenMessageBoxDialog({
                TitleText: "Duplicate File" + (badFiles.length > 1 ? 's' : '') + " Detected",
                MessageText: "The following file" + (badFiles.length > 1 ? 's' : '') + " selected for upload " +
                    ((badFiles.length > 1 ? 'were' : 'was') + " omitted because " + (badFiles.length > 1 ? 'they have' : 'it has') + " the ") +
                    "same file name as one or more files you already have scheduled for uploading to this request record:" +
                    ("<br /><br />" + badFiles.reduce(function (prev, cur) {
                        return prev + ("<div><strong>" + cur.name + " (" + self.fileSizePipe.transform(cur.size, 1) + ")</strong></div>");
                    }, '')),
                OKText: 'OK',
            })
                .subscribe();
        }
    };
    // #endregion
    // #region Is Valid Workday
    CreateComponent.prototype.IsValidWorkday = function (d) {
        var self = this;
        // Ask the app service to validate this as a workday
        var isValid = self.appSvc.IsValidWorkday(d);
        return isValid;
    };
    // #endregion
    // #region Remove File
    CreateComponent.prototype.RemoveFile = function (index) {
        var self = this;
        var attfarr = self.RequestForm.get('RequestUploadAttachments');
        if (index == null || index >= attfarr.length) {
            return;
        }
        var entry = attfarr.at(index).value;
        // Get user confirmation prior to removing the file from upload consideration.
        self.dlgSvc
            .OpenConfirmationDialog({
            TitleText: 'File Removal Confirmation Needed',
            MessageText: "You are about to remove the attachment named " + entry.File.name.toUpperCase() + " from the upload list. Once removed, this file will have to be re-selected in order to be uploaded as part of this request. Are you sure you wish to continue?",
            OKText: 'Yes - Remove File',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to remove the file. Process the request.
                attfarr.removeAt(index);
            }
        });
    };
    // #endregion
    // #region Setup Tracking
    CreateComponent.prototype.SetupTracking = function () {
        var self = this;
        self.unsavedChangesSvc.SetTracking(self.CanDeactivate.bind(self));
    };
    // #endregion
    // #region Take Down Tracking
    CreateComponent.prototype.TakeDownTracking = function () {
        this.unsavedChangesSvc.ClearTracking();
    };
    // #endregion
    // #region Update With Related Request
    CreateComponent.prototype.UpdateWithRelatedRequest = function () {
        var self = this;
        // Find the category in the available list.
        var relCat = self.AllCategories.find(function (c) { return c.CategoryID === self.RelatedRequest.CategoryID; });
        // Find the board member in the available list.
        var relBoard = self.BoardMembers.find(function (b) { return b.SAPID === self.RelatedRequest.RequestorInfo.SAPID; });
        var patch = {
            RequestCategory: relCat,
            Priority: self.RelatedRequest.Priority,
            Confidential: self.RelatedRequest.Confidential,
            RequestBoardMember: relBoard,
            SchoolNumber: self.RelatedRequest.SchoolNumber,
            BoardDistrict: self.RelatedRequest.BoardDistrict,
        };
        self.RequestForm.patchValue(patch);
    };
    return CreateComponent;
}());
export { CreateComponent };
